import { Component, Input, OnInit } from '@angular/core';
import { OrderLine } from '../../../../../_models/orders/order.line';

@Component({
  selector: '[app-easytrade-order-item]',
  templateUrl: './easytrade-order-item.component.html',
  styleUrls: ['./easytrade-order-item.component.scss']
})
export class EasytradeOrderItemComponent implements OnInit {
  @Input() orderLine: OrderLine

  constructor() { }

  ngOnInit(): void {
  }

}
